/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Video_Export_Alpha_Failed_Code_ToastInputs */

const en_video_export_alpha_failed_code_toast = /** @type {(inputs: Video_Export_Alpha_Failed_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alpha video export failed with code: ${i?.code}`)
};

const fr_video_export_alpha_failed_code_toast = /** @type {(inputs: Video_Export_Alpha_Failed_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'exportation video alpha avec le code : ${i?.code}`)
};

const de_video_export_alpha_failed_code_toast = /** @type {(inputs: Video_Export_Alpha_Failed_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alpha-Videoexport fehlgeschlagen mit Code: ${i?.code}`)
};

const it_video_export_alpha_failed_code_toast = /** @type {(inputs: Video_Export_Alpha_Failed_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'esportazione del video Alpha non è riuscita con il codice: ${i?.code}`)
};

const ru_video_export_alpha_failed_code_toast = /** @type {(inputs: Video_Export_Alpha_Failed_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт альфа-канала видео завершился с ошибкой: ${i?.code}`)
};

const es_video_export_alpha_failed_code_toast = /** @type {(inputs: Video_Export_Alpha_Failed_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La exportación de video alfa falló con el código: ${i?.code}`)
};

const zh_cn2_video_export_alpha_failed_code_toast = /** @type {(inputs: Video_Export_Alpha_Failed_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alpha 视频导出失败，错误代码：${i?.code}`)
};

const ja_video_export_alpha_failed_code_toast = /** @type {(inputs: Video_Export_Alpha_Failed_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アルファ ビデオのエクスポートがコード ${i?.code} で失敗しました`)
};

const hi_video_export_alpha_failed_code_toast = /** @type {(inputs: Video_Export_Alpha_Failed_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अल्फा वीडियो निर्यात विफल रहा, कोड: ${i?.code}`)
};

const pt_pt2_video_export_alpha_failed_code_toast = /** @type {(inputs: Video_Export_Alpha_Failed_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A exportação do vídeo alfa falhou com o código: ${i?.code}`)
};

/**
* | output |
* | --- |
* | "Alpha video export failed with code: {code}" |
*
* @param {Video_Export_Alpha_Failed_Code_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_alpha_failed_code_toast = /** @type {((inputs: Video_Export_Alpha_Failed_Code_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Alpha_Failed_Code_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_alpha_failed_code_toast(inputs)
	if (locale === "de") return de_video_export_alpha_failed_code_toast(inputs)
	if (locale === "it") return it_video_export_alpha_failed_code_toast(inputs)
	if (locale === "ru") return ru_video_export_alpha_failed_code_toast(inputs)
	if (locale === "es") return es_video_export_alpha_failed_code_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_alpha_failed_code_toast(inputs)
	if (locale === "ja") return ja_video_export_alpha_failed_code_toast(inputs)
	if (locale === "hi") return hi_video_export_alpha_failed_code_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_alpha_failed_code_toast(inputs)
	return en_video_export_alpha_failed_code_toast(inputs)
});